import { render, staticRenderFns } from "./ChoosePharmacy.vue?vue&type=template&id=50bdaecb"
import script from "./ChoosePharmacy.vue?vue&type=script&lang=js"
export * from "./ChoosePharmacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports